module.exports = __webpack_public_path__ + "images/info@2x.png?87683048";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info@2x.png
// module id = 673
// module chunks = 7